import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './markdown.css';

/**
 * Renders GitHub-flavoured Markdown (headings, tables, bold, lists, hr) as styled
 * HTML. Used for the v0 direct-vision engine, whose analysis is free-form Markdown
 * prose rather than StyleJson. remark-gfm adds table/strikethrough support.
 */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="md">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
